import { render, staticRenderFns } from "./UserDetailsDialog.vue?vue&type=template&id=865102d8&scoped=true"
import script from "./UserDetailsDialog.vue?vue&type=script&lang=js"
export * from "./UserDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865102d8",
  null
  
)

export default component.exports